import { observer } from 'mobx-react';
import * as React from 'react';
import DragIndicatorIcon from '../../../../../Cutesies/DragIndicatorIcon';
import { ExperienceResource } from '../../../../Types';
import LearningCollectionEditStore from '../../../Edit/Store';
import { ModifiableExperiencesContext } from '../../../Types';
import ExperienceRowItems from '../Experiences/CustomizeRow/ExperienceRowItems';
import { ShowUnlicensedToggle } from '../ExperienceCatalog/Types';

interface Props {
  context: ModifiableExperiencesContext;
  store: LearningCollectionEditStore;
  experienceResource: ExperienceResource;
  showLockIcon: ShowUnlicensedToggle;
}

const ExperienceRowItemsWithHandlers: React.FC<Props> = ({
  context,
  store,
  experienceResource,
  showLockIcon,
}) => {
  return (
    <>
      <td className="text-center">
        <input
          className="h-5 w-4 cursor-pointer text-teal-600"
          type="checkbox"
          name="modifyExperience"
          checked={false}
          onChange={() => store.addExperienceStore(context, experienceResource)}
        />
      </td>
      <td className="text-center">
        <div className="inline-block cursor-not-allowed opacity-50">
          <DragIndicatorIcon />
        </div>
      </td>
      <ExperienceRowItems
        context={context}
        experienceResource={experienceResource}
        store={store}
        showLockIcon={showLockIcon}
      />
    </>
  );
};

export default observer(ExperienceRowItemsWithHandlers);
